import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const StickyContainer = superstyled({
  tag: Box,
  name: 'AssistanceStickySection',
  slot: 'StickyContainer',
  styles: ({ theme }) => ({
    position: 'sticky',
    bottom: 64,
    zIndex: 10,
    backgroundColor: theme.palette.background.grey.darker,
    borderRadius: theme.shape.rounded['2xl'],
    boxShadow: '0px 16px 32px -8px rgba(15, 22, 28, 0.12), 0px 8px 16px -4px rgba(15, 22, 28, 0.06)',
    padding: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      bottom: 24,
      padding: theme.spacing(2.5),
    },
  }),
});

export const ActionsStack = superstyled({
  tag: Stack,
  name: 'AssistanceStickySection',
  slot: 'ActionsStack',
  styles: ({ theme }) => ({
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
  }),
});
